import { SxProps, Theme } from "@mui/material/styles";

const styles: SxProps<Theme> = [
  {
    "&.container": {
      maxWidth: 1080,
      margin: "auto",
    },
  },
];
export default styles;
